import type { Opportunity } from '@/types/opportunity';

export function calculateCompliance(opportunities: Opportunity[]): number {
  const total = opportunities.length;
  if (total === 0) return 0;

  const performed = opportunities.filter(
    (opp) => opp.action.actionPerformed
  ).length;

  return (performed / total) * 100;
}

export function calculateComplianceByHCW(
  opportunities: Opportunity[]
): Array<{
  code: string;
  name: string;
  opportunities: number;
  compliance: number;
}> {
  const grouped = new Map<
    string,
    { name: string; total: number; performed: number }
  >();

  for (const opp of opportunities) {
    const existing = grouped.get(opp.observedHCWCode) ?? {
      name: opp.observedHCWName,
      total: 0,
      performed: 0,
    };
    existing.total++;
    if (opp.action.actionPerformed) existing.performed++;
    grouped.set(opp.observedHCWCode, existing);
  }

  return Array.from(grouped.entries()).map(([code, data]) => ({
    code,
    name: data.name,
    opportunities: data.total,
    compliance: data.total > 0 ? (data.performed / data.total) * 100 : 0,
  }));
}
